import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth-pages)/onboarding/")({
  beforeLoad: () => {
    // Redirect to step-1 when visiting /onboarding
    throw redirect({ to: "/onboarding/$step", params: { step: "provider-selection" } });
  },
});
